module.exports = __webpack_public_path__ + "img/kh_cancel.1b02bc81.png";